import React from "react";
import "./ProjectCard.css";

const ProjectCard = ({ title, imageSrc, lang1, lang2, lang3, link, onClick }) => {
  return (
    <div onClick={onClick} className="project">
      <h4>{title}</h4>
      <hr className="line" />
      <div className="image-wrapper">
        <img className="image" src={imageSrc} alt={title} loading="lazy" />
        <div className="image-overlay">
          <p className="image-description">{lang1}</p>
          <p className="image-description">{lang2}</p>
          {lang3 && <p className="image-description">{lang3}</p>}
          {link && (
            <a
              className="anchor"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()} // prevent opening modal when anchor is clicked
              aria-label={`Open ${title}`}
            >
              <span className="anchor-text">Open {title}</span>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
